import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import { RegulatoryContainer } from "@/screens/Products/components/Product/Regulatory/RegulatoryContainer"

export const Route: AnyRoute = createFileRoute("/app/product/$productId/edit/_layout/regulatory")({
  component: RegulatoryContainer,
})
